import { css } from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFontReset } from '../../utilities/styles/fontUtils.js';
import { fontSizes, paddingSize, borderRadiusSize, fontColor, hoverFontColor, hoverBackground, hoverBorder, activeFontColor, activeBackground, activeBorder, rippleKeyframe, backgroundColor, borderColor } from './buttonStyleUtils.js';

/* stylelint-disable */
/*
Color prop values to be passed to Link component if Button has href - key based on button variant.
*/

var LinkTextColors = {
  primary: 'onDark',
  secondary: 'onLightSecondary',
  darkRed: 'onDark',
  darkGray: 'onDark',
  blank: 'onDark'
};
/*
These style-emitting functions are used inthe big style block below, but are also exported for reuse in the button story
*/

var hoverStyle = function hoverStyle(variant) {
  return "\n  color: ".concat(hoverFontColor(variant), ";\n  background-color: ").concat(hoverBackground(variant), ";\n  border-color: ").concat(hoverBorder(variant), ";\n  text-decoration: none;\n");
};
var activeStyle = function activeStyle(variant) {
  return "\n  color: ".concat(activeFontColor(variant), ";\n  background-color: ").concat(activeBackground(variant), ";\n  border-color: ").concat(activeBorder(variant), ";\n");
};
var focusStyle = function focusStyle(variant) {
  return "\n  color: ".concat(fontColor(variant), ";\n  outline: ").concat(ndsTokens.colors.border.focusOutline, " dashed 1px;\n  outline-offset: 2px;\n  -moz-outline-radius: 4px;\n  text-decoration: underline;\n");
};
/* eslint-disable consistent-return */

/* stylelint-disable selector-type-case, selector-type-no-unknown, selector-descendant-combinator-no-non-space, selector-max-empty-lines */

var buttonStyles = css(["", ";position:relative;touch-action:manipulation;background-image:none;border-width:1px;border-style:solid;user-select:none;overflow:hidden;text-overflow:ellipsis;padding:", ";margin:0;border-radius:", ";display:", ";", ";&:focus{", ";}&:hover{", ";}&:active{", ";}&::before{display:block;content:'';position:absolute;border:transparent solid 5px;border-radius:5px;top:-2px;right:-2px;bottom:-2px;left:-2px;opacity:0;animation-duration:500ms;}&:active::before{animation-name:", ";border-color:", ";}&:active:focus{outline:none;}", ";"], function (_ref) {
  var size = _ref.size;
  return ndsFontReset({
    lineHeight: 1.428571429,
    fontSize: fontSizes(size),
    whiteSpace: 'nowrap',
    textAlign: 'center',
    verticalAlign: 'middle'
  });
}, function (_ref2) {
  var size = _ref2.size;
  return paddingSize(size);
}, function (_ref3) {
  var size = _ref3.size;
  return borderRadiusSize(size);
}, function (props) {
  return props.display;
}, function (props) {
  if (props.display === 'block' || props.layout === 'block') {
    return "\n        flex-basis: 100%;\n        width: 100%;\n      ";
  }

  return '';
}, function (props) {
  return focusStyle(props.variant);
}, function (props) {
  return hoverStyle(props.variant);
}, function (props) {
  return activeStyle(props.variant);
}, rippleKeyframe, function (_ref4) {
  var variant = _ref4.variant;
  return activeBorder(variant);
}, function (props) {
  // GTP: this approach is pretty broken, IMO. Bad things happen on focus.
  if (props.loading || props.disabled) {
    return "\n        cursor: ".concat(props.loading ? 'wait' : 'not-allowed', ";\n        animation: none;\n        color: ").concat(ndsTokens.colors.palette.gray.dark, ";\n        background-color: ").concat(ndsTokens.colors.background.lightest, ";\n        border-color: ").concat(ndsTokens.colors.border.container.default, ";\n\n        &:focus {\n          color: ").concat(ndsTokens.colors.palette.gray.dark, ";\n          outline: ").concat(ndsTokens.colors.border.focusOutline, " dashed 1px;\n          outline-offset: 2px;\n          -moz-outline-radius: 4px;\n          text-decoration: none;\n        }\n\n        &:hover {\n          color: ").concat(ndsTokens.colors.palette.gray.dark, ";\n          background-color: ").concat(ndsTokens.colors.background.lightest, ";\n          border-color: ").concat(ndsTokens.colors.border.container.default, ";\n          text-decoration: none;\n          cursor: ").concat(props.loading ? 'wait' : 'not-allowed', ";\n        }\n\n        &:active {\n          color: ").concat(ndsTokens.colors.palette.gray.dark, ";\n          background-color: ").concat(ndsTokens.colors.background.lightest, ";\n          border-color: ").concat(ndsTokens.colors.border.container.default, ";\n          pointer-events: none;\n        }\n\n        &:active::before {\n          animation-name: none;\n          border-color: ").concat(ndsTokens.colors.border.container.default, ";\n        }\n      ");
  }

  return "\n      cursor: pointer;\n      color: ".concat(fontColor(props.variant), ";\n      background-color: ").concat(backgroundColor(props.variant), ";\n      border-color: ").concat(borderColor(props.variant), ";\n    ");
});

export default buttonStyles;
export { LinkTextColors, hoverStyle, activeStyle, focusStyle };
